import AppService from "./app-service"

export default class OrganService extends AppService {

  constructor() {
    super({ path: "organs" })
  }
}